import {
  getInsuranceFlowLabel,
  InsuranceFlowStatus,
} from 'src/app/enums/insurance-flow/insurance-flow-status.enum';

export type CentralisationStepConfig = {
  id: string;
  label: string;
  status: InsuranceFlowStatus;
  required?: boolean;
};

export const CENTRALISATION_STEP_CONFIG: CentralisationStepConfig[] = [
  {
    id: 'centralisation-pending',
    label: getInsuranceFlowLabel(InsuranceFlowStatus.PENDING_CENTRALISATION),
    status: InsuranceFlowStatus.PENDING_CENTRALISATION,
  },
  {
    id: 'centralisation-ongoing',
    label: getInsuranceFlowLabel(InsuranceFlowStatus.ONGOING_CENTRALISATION),
    status: InsuranceFlowStatus.ONGOING_CENTRALISATION,
  },
  {
    id: 'centralisation-finished',
    label: getInsuranceFlowLabel(InsuranceFlowStatus.FINISHED_CENTRALISATION),
    status: InsuranceFlowStatus.FINISHED_CENTRALISATION,
  },
  {
    id: 'centralisation-cancelled',
    label: getInsuranceFlowLabel(InsuranceFlowStatus.CANCELLED_CENTRALISATION),
    status: InsuranceFlowStatus.CANCELLED_CENTRALISATION,
    required: false,
  },
];
